<!-- <button (click)="saveData()"> Test</button> -->
<app-table-standard-layout  [dataSource$]="getLinks" [title]="'Link'" [columnSettings]="columnSettings"
  [rowActionButtons]="rowActionButtons" [topbarActionButton]="topbarActionButton"  [sortByColumn]="'name'">
</app-table-standard-layout>

